module.exports = __webpack_public_path__ + "static/media/bannertall.98f80b76.png";